import React from 'react';
import { Typography, Alert } from '@one-thd/sui-atomic-components';
import { useReturnStore } from '../../stores/returnStore';
var ErrorOrderNumberBarcode = function (_a) {
    var orderName = _a.orderName;
    var orderDetailsV2 = useReturnStore(function (state) { return state.orderDetailsV2; });
    return (React.createElement("div", { className: "sui-mb-8" },
        React.createElement("div", { className: "sui-mb-4" },
            React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, null, "We had a technical issue and couldn\u2019t generate your barcode. You can still give the order number to the store associate to process your return."))),
        React.createElement("div", { className: "sui-flex sui-justify-center" },
            React.createElement(Typography, { weight: "bold", height: "tight" }, orderName || "Order #".concat(orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.orderNumber)))));
};
export default ErrorOrderNumberBarcode;
